if (!customElements.get('featured-slider')) {
  class FeaturedSlider extends HTMLElement {
    constructor() {
      super();
      this.parentSection = this.closest('.custom__featured');
      this.leftArrow = this.parentSection.querySelector('.custom__arrow-left-feat-prods');
      this.rightArrow = this.parentSection.querySelector('.custom__arrow-right-feat-prods');
      this.swiperContainer = this.querySelector('.swiper');
      this.swiper = null;
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      this.swiper = new Swiper(this.swiperContainer, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        loop: true,
        speed: 500,
        centerInsufficientSlides: true,
        centeredSlides: true,
        grabCursor: true,
        navigation: {
          nextEl: this.rightArrow,
          prevEl: this.leftArrow,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return '<div class="' + className + ' recommendations-slide-dot">&nbsp;</div>';
          },
        },
        breakpoints: {
          1000: {
            slidesPerView: 4,
            centeredSlides: false,
          }
        },
        autoHeight: false,
        allowTouchMove: true,
        simulateTouch: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        mousewheel: {
          forceToAxis: true,
        },
        on: {
          init: () => {
            this.handleArrowVisibility();
          },
          slideChange: () => {
            this.handleArrowVisibility();
          },
          resize: () => {
            this.handleArrowVisibility();
          }
        }
      });

      this.swiper.slidesPerViewDynamic()

      // Handle window resize
      window.addEventListener('resize', () => {
        if (this.swiper) {
          this.swiper.update();
          this.handleArrowVisibility();
        }
      });
    }

    handleArrowVisibility() {
      if (!this.swiper || !this.leftArrow || !this.rightArrow) return;

      const totalSlides = this.swiper.slides.length;
      const slidesPerView = this.swiper.params.slidesPerView;
      const isLoop = this.swiper.params.loop;

      // Show/hide arrows based on number of slides
      if (totalSlides <= slidesPerView && !isLoop) {
        this.leftArrow.classList.add('custom__arrow--hidden');
        this.rightArrow.classList.add('custom__arrow--hidden');
      } else {
        this.leftArrow.classList.remove('custom__arrow--hidden');
        this.rightArrow.classList.remove('custom__arrow--hidden');
      }
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('featured-slider', FeaturedSlider);
}